import axios from '@axios'

export default {
  getPaymentStatus(page, field) {
    return axios.post(`platform/payment_status/list?page=${page}`, field)
  },
}
